import { BwhsApiError } from './bwhsApiClient';

export enum ErrorSeverity {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Critical = 'critical',
}

export interface ErrorContext {
  component?: string;
  action?: string;
  userId?: string;
  orderId?: string;
  [key: string]: unknown;
}

interface ErrorData {
  message: string;
  stack?: string;
  severity: ErrorSeverity;
  context?: ErrorContext;
  timestamp: string;
  url: string;
  userAgent: string;
}

class ErrorLogger {
  private enabled: boolean;

  constructor() {
    this.enabled = process.env.NODE_ENV === 'production';
  }

  log(
    error: Error | string,
    severity: ErrorSeverity = ErrorSeverity.Error,
    context?: ErrorContext
  ): void {
    const errorData: ErrorData = {
      message: typeof error === 'string' ? error : error.message,
      stack: error instanceof Error ? error.stack : undefined,
      severity,
      context,
      timestamp: new Date().toISOString(),
      url: window.location.href,
      userAgent: navigator.userAgent,
    };

    // Log to console in development
    if (process.env.NODE_ENV === 'development') {
      console.error('[ErrorLogger]', errorData);
    }

    // Send to monitoring service in production
    if (this.enabled) {
      // TODO: Integrate Sentry, LogRocket, or similar
      // Sentry.captureException(error, { contexts: { custom: context } });
      this.sendToMonitoringService(errorData);
    }
  }

  logApiError(error: BwhsApiError, context?: ErrorContext): void {
    this.log(error, ErrorSeverity.Error, {
      ...context,
      errorCode: error.code,
      apiError: true,
    });
  }

  logUserAction(action: string, context?: ErrorContext): void {
    this.log(action, ErrorSeverity.Info, context);
  }

  private sendToMonitoringService(errorData: ErrorData): void {
    // Placeholder for future monitoring service integration
    // This could be Sentry, LogRocket, or a custom endpoint
    console.warn('[ErrorLogger] Monitoring service not configured', errorData);
  }
}

export const errorLogger = new ErrorLogger();
